module.exports = __webpack_public_path__ + "img/tennis.6ae3c573.gif";